import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import {
  PageWrapperSidebarItemLink,
  type PropsIcon
} from '../Sidebar/components/Item/PageWrapperSidebarItemLink';
import { AccordionMenuItem } from '../../../AccordionMenuItem';
import { AuthService } from '../../../../services/AuthService';
import ExitIcon from '@/assets/icon/components/ExitIcon';
import {
  BANNER_PAGES,
  FEEDBACK_PAGES,
  PRODUCT_PAGES,
  VENDOR_TABLES
} from '../..';
import { PageWrapperSidebarItemButton } from '../Sidebar/components/Item/PageWrapperSidebarItemButton';
import './menu.css';

interface MobileMenuProps {
  isShortSideBar: boolean;
  setIsShortSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  setIsVendorAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsBannerAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsProductAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFeedbackAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isVendorAccordionOpen: boolean;
  isBannerAccordionOpen: boolean;
  isProductAccordionOpen: boolean;
  isFeedbackAccordionOpen: boolean;
  OnlineStore: React.FC<PropsIcon>;
  ShoppingCart: React.FC<PropsIcon>;
  ShoppingBag: React.FC<React.SVGProps<SVGSVGElement>>;
  PriceVoucher: React.FC<PropsIcon>;
  ProfileSvg: React.FC<PropsIcon>;
  ProviderIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  BannersIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  ChatIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  AddedUserIcon: React.FC<PropsIcon>;
  SettingsIcon: React.FC<PropsIcon>;
  show: boolean;
  handleClose: () => void;
  className?: string;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  isShortSideBar,
  setIsShortSideBar,
  setIsVendorAccordionOpen,
  setIsBannerAccordionOpen,
  setIsProductAccordionOpen,
  setIsFeedbackAccordionOpen,
  isVendorAccordionOpen,
  isBannerAccordionOpen,
  isProductAccordionOpen,
  isFeedbackAccordionOpen,
  OnlineStore,
  ShoppingCart,
  ShoppingBag,
  PriceVoucher,
  ProfileSvg,
  ProviderIcon,
  BannersIcon,
  SettingsIcon,
  AddedUserIcon,
  ChatIcon,
  show,
  handleClose,
  className
}) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="top"
        className={`custom-offcanvas ${className}`}
      >
        <Offcanvas.Header closeButton className="custom-offcanvas-header">
          <Offcanvas.Title>Меню</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="wrapper-items">
            <PageWrapperSidebarItemLink
              Icon={OnlineStore}
              title="Главная"
              href="/"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemLink
              Icon={ShoppingCart}
              title="Заказы"
              href="/orders"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <AccordionMenuItem
              setIsShortSideBar={setIsShortSideBar}
              isShortSideBar={isShortSideBar}
              setIsAccordionOpen={setIsProductAccordionOpen}
              isAccordionOpen={isProductAccordionOpen}
              title="Товары"
              items={PRODUCT_PAGES}
              IconComponent={ShoppingBag}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemLink
              Icon={PriceVoucher}
              title="Промокоды"
              href="/promocodes"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemLink
              Icon={ProfileSvg}
              title="Клиенты"
              href="/clients"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <AccordionMenuItem
              setIsShortSideBar={setIsShortSideBar}
              isShortSideBar={isShortSideBar}
              setIsAccordionOpen={setIsVendorAccordionOpen}
              isAccordionOpen={isVendorAccordionOpen}
              title="Поставщики"
              items={VENDOR_TABLES}
              IconComponent={ProviderIcon}
              onHide={handleClose}
            />
            <AccordionMenuItem
              setIsShortSideBar={setIsShortSideBar}
              isShortSideBar={isShortSideBar}
              setIsAccordionOpen={setIsBannerAccordionOpen}
              isAccordionOpen={isBannerAccordionOpen}
              title="Баннеры"
              items={BANNER_PAGES}
              IconComponent={BannersIcon}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemLink
              Icon={AddedUserIcon}
              title="Менеджеры"
              href="/managers"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <AccordionMenuItem
              setIsShortSideBar={setIsShortSideBar}
              isShortSideBar={isShortSideBar}
              setIsAccordionOpen={setIsFeedbackAccordionOpen}
              isAccordionOpen={isFeedbackAccordionOpen}
              title="Обратная связь"
              items={FEEDBACK_PAGES}
              IconComponent={ChatIcon}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemLink
              Icon={SettingsIcon}
              title="Настройки"
              href="/settings"
              isShortSideBar={isShortSideBar}
              onHide={handleClose}
            />
            <PageWrapperSidebarItemButton
              Icon={ExitIcon}
              isShortSideBar={isShortSideBar}
              title="Выйти"
              onClick={() => {
                AuthService.logout();
              }}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MobileMenu;
